import BellIconPath from "@ingka/ssr-icon/paths/bell";

export default BellIconPath;
